import { Component } from '@angular/core';
import { LanguageService } from '@uigy/shared/services/language.service';

@Component({
    selector: 'app-license-expired',
    templateUrl: './license-expired.component.html',
    styleUrls: ['./license-expired.component.scss'],
    standalone: false
})
export class LicenseExpiredComponent {
  public texts = this.languageService.texts.mini_layout_pages.license_expired;

  constructor(
    private languageService: LanguageService,
  ) { }
}
